import { themeV1Schema, type ThemeV1 } from "./schema";

function deepFreeze<T>(value: T): T {
  if (value && typeof value === "object" && !Object.isFrozen(value)) {
    for (const nested of Object.values(value)) deepFreeze(nested);
    Object.freeze(value);
  }
  return value;
}

const neutralInput = {
  schemaVersion: 1,
  preset: "neutral",
  shellVariant: "neutral",
  fontPreset: "system",
  brand: {
    displayName: "Horseracing World",
    shortName: "HW",
    markAssetKey: null,
    wordmarkAssetKey: null,
    logoAlt: "Horseracing World",
  },
  colors: {
    page: "#09121b",
    surface: "#101e2c",
    surfaceRaised: "#1a2d40",
    border: "#22384d",
    text: "#f1f5f8",
    textMuted: "#8495a5",
    primary: "#1ea7f2",
    primaryStrong: "#1689c8",
    primaryHover: "#39b7ff",
    onPrimary: "#06111a",
  },
  assets: { sidebarBackgroundKey: null, faviconKey: null },
  products: [
    {
      id: "casino",
      label: "Casino",
      shortLabel: "Casino",
      iconId: "casino",
      href: null,
      enabled: false,
    },
    {
      id: "sports",
      label: "Sports",
      shortLabel: "Sports",
      iconId: "sports",
      href: null,
      enabled: false,
    },
    {
      id: "rips",
      label: "Rips",
      shortLabel: "Rips",
      iconId: "rips",
      href: null,
      enabled: false,
    },
    {
      id: "racing",
      label: "Horse Racing",
      shortLabel: "Racing",
      iconId: "racing",
      href: "/app/",
      enabled: true,
    },
  ],
  heroId: null,
} as const;

const monkeyTiltInput = {
  schemaVersion: 1,
  preset: "monkeytilt",
  shellVariant: "monkeytilt-v2",
  fontPreset: "monkeytilt",
  brand: {
    displayName: "Tilt Racing",
    shortName: "Tilt Racing",
    markAssetKey: "monkeytilt-mark",
    wordmarkAssetKey: "tilt-racing-logo",
    logoAlt: "Tilt Racing",
  },
  colors: {
    page: "#09090b",
    surface: "#18181b",
    surfaceRaised: "#27272a",
    border: "#3f3f46",
    text: "#fafafa",
    textMuted: "#a1a1aa",
    primary: "#ffe500",
    primaryStrong: "#f4dc03",
    primaryHover: "#eab308",
    onPrimary: "#09090b",
  },
  assets: {
    sidebarBackgroundKey: "monkeytilt-sidebar",
    faviconKey: "monkeytilt-favicon",
  },
  products: [
    {
      id: "casino",
      label: "Casino",
      shortLabel: "Casino",
      iconId: "casino",
      href: "https://vault.mt-dev.ue2.monkeytilt.pro/casino/",
      enabled: true,
    },
    {
      id: "sports",
      label: "Sports",
      shortLabel: "Sports",
      iconId: "sports",
      href: "https://vault.mt-dev.ue2.monkeytilt.pro/sports/",
      enabled: true,
    },
    {
      id: "rips",
      label: "Rips",
      shortLabel: "Rips",
      iconId: "rips",
      href: "https://tiltrips.mt-dev.ue2.monkeytilt.pro/",
      enabled: true,
    },
    {
      id: "racing",
      label: "Tilt Racing",
      shortLabel: "Tilt Racing",
      iconId: "racing",
      href: "/app/",
      enabled: true,
    },
  ],
  heroId: null,
} as const;

export const neutralTheme = deepFreeze(
  themeV1Schema.parse(neutralInput),
) satisfies ThemeV1;
export const monkeyTiltTheme = deepFreeze(
  themeV1Schema.parse(monkeyTiltInput),
) satisfies ThemeV1;

export const themePresets = Object.freeze({
  neutral: neutralTheme,
  monkeytilt: monkeyTiltTheme,
});
